import type { Contract, ContractApi } from '../../models';
import { normalizeCreateContract } from '../create-contract';

export const normalizeUpdateContract = (contract: Contract): ContractApi => ({
  ...normalizeCreateContract(contract),
  approvedBy: contract.approvedBy,
  approvedOn: contract.approvedOn,
  createdBy: contract.createdBy,
  createdOn: contract.createdOn,
  deletedBy: contract.deletedBy,
  deletedOn: contract.deletedOn,
  key: contract.key,
  modifiedBy: contract.modifiedBy,
  modifiedOn: contract.modifiedOn,
});
